// extracted by mini-css-extract-plugin
export default {"root":"ErrorBoundary_root__3QpuC","message":"ErrorBoundary_message__dRl07"};